<script>
    import { debounce, forEach, isFunction, isNull, filter, map } from 'lodash/lodash'
    import Page from './Page.vue'
    import CalculationInfo from './CalculationInfo.vue'
    import CalculationFooter from './CalculationFooter.vue'
    import Navigation from './Navigation.vue'
    import { loading } from '../core/page-loader'
    import { checkInCalcFooterOffset, scrollToTop, placeholderFormater } from '../utility'
    import EditableVariableModal from '../modals/EditableVariableModal.vue'
    import CalculationNameModal from '../modals/CalculationNameModal.vue'
    import CalculationOverviewModal from '../modals/CalculationOverviewModal.vue'
    import ImageModal from '../modals/ImageModal.vue'
    import LoseCalculationWarningModal from '../modals/LoseCalculationWarningModal.vue'
    import LoginFirstModal from '../modals/LoginFirstModal.vue'
    import ChangeWarningModal from '../modals/ChangeWarningModal.vue'
    import { stripTags } from '../utility'

    export default {
        el: '#eventcalculator',
        name: 'EventCalculator',
        // i18n: {
        //     locale: 'en'
        // },
        components: { 
            Page,
            CalculationInfo,
            Navigation,
            CalculationFooter,
            CalculationNameModal,
            ImageModal,
            CalculationOverviewModal, 
            EditableVariableModal,
            LoseCalculationWarningModal,
            LoginFirstModal,
            ChangeWarningModal
        },
        data() { return {
            debug: true,
            recalculating: false,
            startOrder: null,
            requestNumber: 0,
            requesting: true,
            afterRecalculating: null,
            lastResponse: {},
            followRequest: false,
            requestChangedWhileCalculate: null
        }},
        computed: {
            isRdyToSend: function () {
                let status = true

                forEach(this.$store.rdyToSend, function(value) {
                    if(!value) {
                        status = false
                        return false
                    }
                })

                return status
            },
            isFirstPage: function() {
                return this.startOrder >= this.$store.page.sortOrder
            },
            isLoading: function() {
                if(this.requesting && !this.recalculating) {
                    return true
                }

                return false
            }
        },
        watch: {
            isLoading: {
                handler: function(value) {
                    loading(value)
                },
                immediate: true
            }
        },
        created() {
            this.$event.$on('next', this.next)
            this.$event.$on('prev', this.prev)
            
            this.$event.$on('calculation-changed', () => {
                if(!this.$store.preventSendData && this.isRdyToSend) {
                    this.$event.$emit('start-recalculation')
                    this.recalculate()
                }
            })
        },
        beforeMount() {
            this.$store.calculationName = this.$el.getAttribute('data-calculation-name')
            this.$store.globals = JSON.parse(this.$el.getAttribute('data-globals'))
            this.$store.publicId = this.$el.getAttribute('data-public-id')

            if(this.$el.getAttribute('data-read-only')) {
                this.$store.readOnly = true
                this.$store.readOnlyCode = this.$el.getAttribute('data-read-only-code')
            }
        },
        mounted() {
            this.fetchPage()
        },
        methods: {
            fetchPage(responseData = null, direction = 'next') {
                let uri = this.$store.axiosBase+direction
                this.requesting = true
                this.lastResponse = {}

                if(this.$store.readOnlyCode) {
                    uri = uri + "?readonly=" + this.$store.readOnlyCode
                }

                axios.post(uri, {
                    responses: responseData,
                    requestNumber: this.requestNumber++
                })
                .then(this.setResponse)
            },
            next() {
                if(!this.isRdyToSend || (this.requesting && !this.recalculating)) return

                if(this.recalculating) {
                    if(isNull(this.afterRecalculating)) {
                        loading(true)
                        this.afterRecalculating = this.next
                    }

                    return
                }

                let responseData = this.getResponseData()
                responseData.next = true

                this.fetchPage(responseData, 'next')
            },
            prev() {
                if(this.requesting && !this.recalculating) return

                if(this.recalculating) {
                    if(isNull(this.afterRecalculating)) {
                        loading(true)
                        this.afterRecalculating = this.prev
                    }
                    
                    return
                }

                this.fetchPage(null, 'prev')
            },
            recalculate: debounce(function () {
                if(this.requesting) {
                    this.requestChangedWhileCalculate = true
                    return
                }

                this.$event.$emit('start-recalculation')
                this.requesting = true
                this.recalculating = true
                let responseData = this.getResponseData()
                let liveFormulas = []

                forEach(this.$store.liveFormulas, function(value) {
                    liveFormulas.push((value.formula) ? value.formula : value)     
                })

                axios.post(this.$store.axiosBase+'calculate', {
                    responses: responseData,
                    'live-formulas': liveFormulas,
                    requestNumber: this.requestNumber++
                }).then((response) => {
                    this.recalculating = false
                    this.requesting = false

                    if(this.requestChangedWhileCalculate) {
                        this.requestChangedWhileCalculate = false
                        this.$event.$emit('calculation-changed')

                        return
                    }

                    this.$store.calculation = response.data
                    this.$event.$emit('new-data', response.data)
                    
                    if(isFunction(this.afterRecalculating)) {
                        this.afterRecalculating()
                        this.afterRecalculating = null
                    }
                }).catch((thrown) => {
                    this.requesting = false
                    this.recalculating = false

                    if (axios.isCancel(thrown)) {
                        console.log('Request canceled', thrown.message)
                    }
                })
            }, 400),
            prepareDataAfterFetch(data) {
                return data
            },
            setResponse(response) {
                this.$store.colorizedQuestions = []
                this.$store.liveFormulas = []
                this.$store.pageVariables = []
                this.$store.page = this.prepareDataAfterFetch(response.data.page)
                this.$store.calculation = response.data.calculation
                this.$event.$emit('new-data', response.data.calculation)
                this.requesting = false
                this.lastResponse = response
                this.setgoogleTag()
                                
                this.$nextTick(function() {
                    $('.placeholder:not(.live-formula):not(.ec-inline-editable-variable)', '.ec-page').each((key, el) => {
                        placeholderFormater(el)
                    })

                    scrollToTop()
                    checkInCalcFooterOffset()
                })
            },
            getResponseData() {
                if(this.$store.preventSendData) {
                   return {}
                }

                let responseData = this.$refs.page.getResponseData()

                if(responseData.questions) {
                    responseData.questions = filter(responseData.questions)
                }

                return responseData
            },
            setgoogleTag() {   
                let craft = '0'
                let pagePath = `/eventcalculator/craft/${this.$store.page.craft_id}/${this.$store.page.pageContentType}/${this.$store.page.pageId}`

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'pageviewCustomEvent',
                    pagePath,
                    pageTitle: stripTags(this.$store.page.headline)
                });
            }
        }
    }
</script>